module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hrms-dropzone"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.maxNumberOfFiles > 0),
      expression: "maxNumberOfFiles > 0"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disabled),
      expression: "disabled"
    }]
  }, [_vm._v("\n      Upload Here\n    ")]), _vm._v(" "), _c('vue-dropzone', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disabled),
      expression: "!disabled"
    }],
    ref: "vueDropzoneMultiCall",
    class: {
      'input-error': _vm.hasError
    },
    attrs: {
      "id": _vm.name,
      "url": _vm.url,
      "headers": _vm.headers,
      "useFontAwesome": true,
      "maxNumberOfFiles": _vm.maxNumberOfFiles,
      "showRemoveLink": _vm.showRemoveLink,
      "maxFileSizeInMB": _vm.maxFileSizeInMB,
      "acceptedFileTypes": _vm.acceptedFileTypes
    },
    on: {
      "vdropzone-sending": _vm.validateFileName,
      "vdropzone-removed-file": _vm.postDeleteFile,
      "vdropzone-success": _vm.addFileTemp,
      "vdropzone-error": _vm.triggerError
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-remark _text-blue"
  }, [_c('ul', [_c('li', [_vm._v("File name must only contain alphanumeric characters with no spaces and hiphen.")]), _vm._v(" "), _c('li', [_vm._v("Maximum size of 2 MB is allowed.")]), _vm._v(" "), _c('li', [_vm._v("Maximum " + _vm._s(_vm.maxNumberOfFiles) + " files.")])])])])], 1), _vm._v(" "), _vm._l((_vm.fileOutPut), function(file, index) {
    return _c('div', {
      key: index
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.dispAttach && file.status === ''),
        expression: "!dispAttach && file.status === ''"
      }]
    }, [_vm._v(_vm._s(file.fileName) + "\n      "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filePath + file.fileName),
        expression: "filePath + file.fileName"
      }],
      staticClass: "fa fa-paperclip ico-knowledge1 dash-color-skin",
      attrs: {
        "href": _vm.filePath + file.fileName,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filePath + file.fileName),
        expression: "filePath + file.fileName"
      }],
      staticClass: "fa fa-trash ico-knowledge1 cursor-pointer",
      on: {
        "click": function($event) {
          _vm.deleteFileTemp(file.fileName)
        }
      }
    })])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1eba1155!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsDropzoneMulti/component.vue
// module id = 3616
// module chunks = 1